export const DISPLAY_TOAST_TIME = 2_000;
export const TOAST_ANIMATION_TIME = 300;
